var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnhanceAi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 3.73333L3.33337 4.66666L4.26671 2.99999L3.33337 1.33333L5.00004 2.26666L6.66671 1.33333L5.73337 2.99999L6.66671 4.66666L5.00004 3.73333ZM13 10.2667L14.6667 9.33333L13.7334 11L14.6667 12.6667L13 11.7333L11.3334 12.6667L12.2667 11L11.3334 9.33333L13 10.2667ZM14.6667 1.33333L13.7334 2.99999L14.6667 4.66666L13 3.73333L11.3334 4.66666L12.2667 2.99999L11.3334 1.33333L13 2.26666L14.6667 1.33333ZM8.89337 8.51999L10.52 6.89333L9.10671 5.48L7.48004 7.10666L8.89337 8.51999ZM9.58004 4.85999L11.14 6.42C11.4 6.66666 11.4 7.09999 11.14 7.35999L3.36004 15.14C3.10004 15.4 2.66671 15.4 2.42004 15.14L0.860039 13.58C0.600039 13.3333 0.600039 12.9 0.860039 12.64L8.64004 4.85999C8.90004 4.59999 9.33337 4.59999 9.58004 4.85999Z",
    fill: "#2ECBB8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnhanceAi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/enhanceAI.981636ae.svg";
export { ForwardRef as ReactComponent };